import { isJSON } from '@st/utils-js';
import ElementAttrs from './ElementAttrs';
import UserRolle from './enums/UserRolle';
import Responsibilities from './Responsibilities';

const REQUIRED_ROLES = [UserRolle.PARTNER, UserRolle.ADMINPARTNER, UserRolle.RECHTSANWALT];
export default class BausteinElementAttrs extends ElementAttrs {
  /**
   *
   * @param {String} name
   * @param {Array} hashtags Array of UUIDs
   * @param {Responsibilities} responsibilities
   */
  constructor(name = null, hashtags = [], responsibilities = new Responsibilities()) {
    super(name, hashtags, responsibilities, REQUIRED_ROLES);
  }

  /**
   * Creates BausteinElementAttrs from JSON.
   * If keys are missing then it will use the default values.
   * @param {JSON} value
   * @returns null if invalid
   */
  static fromJSON(value) {
    if (!isJSON(value)) return null;

    const { name = '', hashtags = [], responsibilities = new Responsibilities() } = value;

    let res = responsibilities;
    if (!(res instanceof Responsibilities) && isJSON(res)) {
      res = Responsibilities.fromJSON(res);
    }

    return new BausteinElementAttrs(name, hashtags, res);
  }

  /**
   * @returns BausteinElementAttrs in JSON representation
   */
  toJSON() {
    let responsibilities = {};
    if (this.responsibilities instanceof Responsibilities) {
      responsibilities = this.responsibilities.toJSON();
    } else {
      responsibilities = this.responsibilities;
    }

    return {
      name: this.name,
      hashtags: this.hashtags,
      responsibilities,
    };
  }

  get valid() {
    const { validName, validHashtags, validResponsibilities } = this;

    const valid = validName && validHashtags && validResponsibilities;

    return valid;
  }
}
